export class ApiError extends Error {
    static readonly NAME = 'ApiError';

    constructor(message?: string) {
        super(message);
        this.name = ApiError.NAME;
    }
}
